"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { getBaseLocale } from "@/lib/i18n";

function getLocaleFromPathname(pathname: string): string {
  const first = pathname.split("/").filter(Boolean)[0];
  return first || "ru";
}

export default function NotFound() {
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname);
  const isEn = getBaseLocale(locale) === "en";

  return (
    <div className="mx-auto max-w-3xl px-4 py-24 text-white/90">
      <h1 className="text-2xl md:text-3xl font-medium">
        {isEn ? "Page not found" : "Страница не найдена"}
      </h1>
      <p className="mt-4 text-sm text-white/70">
        {isEn
          ? "The page you are looking for may have been moved or removed."
          : "Возможно, страница была удалена или перемещена."}
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button asChild>
          <Link href={`/${locale}`}>{isEn ? "Go to homepage" : "На главную"}</Link>
        </Button>
        <Button asChild variant="outline">
          <Link href={`/${locale}/contacts`}>{isEn ? "Contacts" : "Контакты"}</Link>
        </Button>
      </div>
    </div>
  );
}
